module.exports = __webpack_public_path__ + "img/software.03a02797.jpg";